export default __webpack_public_path__ + "static/media/cross-red.ef8f2eae.svg";